var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tile",class:{ vacant: _vm.vacant }},[(!_vm.vacant)?_c('TileOffset',{attrs:{"flipY":_vm.flipY}},[(!_vm.vacant)?_c(_vm.catComponentType,{ref:"cat",tag:"component",attrs:{"breed":_vm.breed,"initialState":_vm.initialCatState,"walkDistance":_vm.columnsFromEdge},on:{"remove":_vm.removeCat,"died":_vm.block}}):_vm._e()],1):_vm._e()],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74f3d7ec","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/board/Tile.vue
// module id = null
// module chunks = 